<script setup lang="ts">
  import Button from '@leaflink/stash/Button.vue';
  import Modal from '@leaflink/stash/Modal.vue';
  import { storeToRefs } from 'pinia';

  import { ROUTE_NAMES } from '@/constants';
  import { useCompanyStore } from '@/piniaStores/company/company.store';
  import i18n from '@/plugins/i18n';

  const emit = defineEmits<{
    (e: 'dismiss'): void;
    (e: 'signUp'): void;
  }>();

  const companyStore = useCompanyStore();
  const { pendingPaymentProgramRequests } = storeToRefs(companyStore);
</script>

<template>
  <Modal hide-header :is-open="true" @dismiss="emit('dismiss')">
    <template #featured-content>
      <div class="tw-relative">
        <img
          :src="'/static/img/direct-pay/direct-pay-promo-bg.svg'"
          class="tw-object-cover tw-w-full tw-rounded-r"
          role="presentation"
        />
        <div class="tw-absolute tw-inset-0 tw-flex tw-items-center">
          <img
            class="tw-w-full"
            :src="'/static/img/direct-pay/direct-pay-promo-seller.svg'"
            data-test="promo-image | seller"
          />
        </div>
      </div>
    </template>

    <h2 class="tw-mb-6">
      <template v-if="pendingPaymentProgramRequests.length > 1">
        {{
          i18n.t('directPaySignupModal.headerMultiple', {
            numberOfBuyers: pendingPaymentProgramRequests.length,
          })
        }}
      </template>
      <template v-else>
        {{
          i18n.t('directPaySignupModal.headerSingle', {
            companyName: pendingPaymentProgramRequests[0]?.counterParty.dba,
          })
        }}
      </template>
    </h2>
    <p>
      {{ i18n.t('directPaySignupModal.body') }}
    </p>
    <p>
      <router-link
        :to="{
          name: ROUTE_NAMES.JOIN_TODAY_PAYMENTS,
          query: { type: 'seller-direct' },
        }"
        @click="emit('dismiss')"
      >
        {{ i18n.t('common.learnMore') }}
      </router-link>
    </p>
    <template #actions>
      <Button secondary @click="emit('dismiss')">{{ i18n.t('directPaySignupModal.maybeLater') }}</Button>
      <Button @click="emit('signUp')">{{ i18n.t('common.signUp') }}</Button>
    </template>
  </Modal>
</template>
